import axios from 'axios'
import React, { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Box from '../components/Box'
import Breadcrumb from '../components/Breadcrumb'
import Color from '../components/Color'
import ManageTable from '../components/ManageTable'
import { TableHeaderDataProps } from '../components/Table'
import { fetchLocation } from '../fetchers/fetcher'
import { errorCallback } from '../helpers/errorCallback'
import { errorMessage } from '../helpers/errorMessage'
import useAlert from '../hooks/useAlert'
import useLogin from '../hooks/useLogin'
import {DeleteIcon, EditIcon} from '../icons/icon'
import { ILocation } from '../types/types'

const breadCrumbItems = [
    { name: "Location Maintenance", active: true },
]

let defaultHeader: TableHeaderDataProps[] = [
    { key: "l_id", name: "ID", width: "4%", sort: "unsort" },
    { key: "date_time", name: "Date", width: "6%", sort: "unsort" },
    { key: "location", name: "Location", sort: "unsort" },
    { key: "address", name: "Address" },
    { key: "contact_person", name: "Contact Person" },
    { key: "contact_no", name: "Contact No." },
    { key: "type", name: "Type", width: "5%" },
    { key: "status", name: "Status", width: "5%" },
    { key: "action", name: "Action", align: "center", width: "5%" },
]

const LocationList = () => {
    let history = useNavigate()
    const {token, setToken} = useLogin()
    const [data, setData] = useState<any[]>([])
    const [loading, setLoading] = useState(true)
    const [reload, setReload] = useState(false)

    const {setAlert} = useAlert()

    const handleDelete = useCallback((_data: ILocation) => {
        setAlert({
            show: true,
            message: "Delete " + _data.location + " ?",
            type: "danger",
            cb: async () => {
                try {
                    let result = await axios.delete("/location/" + _data.l_id)
        
                    if(result.status !== 200) {
                        setAlert({
                            show: true,
                            message: result.data.message,
                            type: "danger"
                        })
                    }
        
                    return setAlert({
                        show: true,
                        message: _data.location + " Deleted Successfully !!!",
                        type: "success",
                        cb: () => {
                            setData(v => v.filter(row => row.l_id !== _data.l_id))
                        }
                    })
        
                } catch (err: any) {
                    console.log(err.message)
                    setAlert({
                        show: true,
                        type: "danger",
                        message: err.message
                    })
                }
            }
        })
    }, [setAlert])

    const fetchData = useCallback(async () => {
        setLoading(true)
        try {
            let _data = await fetchLocation(token)

            if(Array.isArray(_data)) {
                setData(_data.map(row => ({ 
                    ...row,
                    address: row.add1 + " " + row.add2 + " " + row.add3,
                    status: <Color color={row.status === "active" ? "green" : "red"}>{row.status}</Color>,
                    action: <Box justifyContent='center' alignItems='center'>
                        <EditIcon iconcolor="blue" iconsize='h6' onClick={() => history("/location/" + row.l_id)} />
                        <DeleteIcon iconcolor="red" iconsize='h6' onClick={() => handleDelete(row)} />
                    </Box>
                })))
                setLoading(false)
            }
        } catch (err: any) {
            console.log(err.message)
            setLoading(false)
            setAlert({
                show: true,
                message: err.message,
                type: "danger",
                ok: errorMessage(err.message),
                cb: () => errorCallback(err.message, setReload, reload, setToken)
            })
        }

  
    }, [token, history, reload, setAlert, setToken, handleDelete])

    useEffect(() => {
        fetchData()
    }, [fetchData])

    return (
        <>
            <Breadcrumb items={breadCrumbItems} 
            button={[
                {
                    name: "New",
                    action: "/location/new",
                    color: "blue"
                }
            ]} 
            />
            <ManageTable 
            defaultHeader={defaultHeader}
            columnSetting="locationList"
            data={data}
            filterKey={["location"]}
            loading={loading}
            />
        </>
    )
}

export default LocationList